// Input row — auto-resize textarea + send button.
import React from "react";
import { Send } from "lucide-react";
import { MAX_TURNS } from "./aiChatConstants";

export const ChatInputBar = ({ input, setInput, busy, taRef, userTurns, onSend }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };
  return (
    <div
      className="px-4 sm:px-8 py-4"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)", background: "#0a0c12" }}
    >
      <div
        className="flex items-end gap-3 rounded-lg px-3 py-2"
        style={{ background: "#0d0f18", border: "1px solid rgba(255,255,255,0.10)" }}
      >
        <textarea
          ref={taRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Describe the situation…"
          disabled={busy}
          rows={1}
          className="flex-1 resize-none outline-none bg-transparent"
          style={{
            color: "#f0f2f8",
            fontFamily: "'DM Mono', monospace",
            fontSize: 13,
            lineHeight: 1.45,
            minHeight: 22,
            maxHeight: 96,
          }}
          data-testid="ai-chat-input"
        />
        <button
          onClick={onSend}
          disabled={busy || !input.trim()}
          className="flex items-center justify-center rounded-md"
          style={{
            width: 36,
            height: 36,
            background: busy || !input.trim() ? "rgba(24,95,165,0.30)" : "#185FA5",
            border: "1px solid rgba(24,95,165,0.55)",
            color: "#fff",
            cursor: busy || !input.trim() ? "not-allowed" : "pointer",
          }}
          data-testid="ai-chat-send"
          aria-label="Send"
        >
          <Send size={15} />
        </button>
      </div>
      <div
        className="mt-2 px-1"
        style={{
          fontFamily: "'DM Mono', monospace",
          fontSize: 10,
          color: "#5a6080",
          letterSpacing: "0.4px",
        }}
      >
        Enter to send · Shift+Enter for newline · {MAX_TURNS - userTurns} turn(s) left
      </div>
    </div>
  );
};
